import React from 'react';
import { Button, Modal, ModalFooter, ModalHeader, ModalText } from 'components';
import { theme } from 'design';
import { splitPayPeriodClosedMessage } from 'utils/errors';
import AlertHeader from '../components/Alert/AlertHeader';
import { HeaderContent } from './styles';

interface IPayPeriodClosedModalProps {
  isActive: boolean;
  verb: 'dismiss' | 'remove' | 'delete';
  message: string;
  onClose: () => void;
}

/**
 * Shown when account_services refuses a dismiss, remove or delete because the employee has pending or expired payments
 * in a closed pay period. The API message names the site and period and says what to do next.
 */
export const PayPeriodClosedModal: React.FC<IPayPeriodClosedModalProps> = ({ isActive, verb, message, onClose }) => {
  const { reason, nextStep } = splitPayPeriodClosedMessage(message);

  return (
    <Modal maxWidth={540} isActive={isActive} onClose={onClose} dataCy="pay-period-closed-modal">
      <ModalHeader style={{ paddingBottom: '0' }}>
        <HeaderContent>
          <AlertHeader icon="Caution" iconFill={theme.color.warning[50]} title={`Unable to ${verb} employee`} />
          <ModalText>{reason}</ModalText>
          {nextStep && <ModalText>{nextStep}</ModalText>}
        </HeaderContent>
      </ModalHeader>
      <ModalFooter columns={1}>
        <Button label="Close" appearance="white" size="large" onClick={onClose} data-cy="pay-period-closed-close-button" />
      </ModalFooter>
    </Modal>
  );
};
